const isHelp = result => result?.category?.raw === 'Help Article'
const isGuide = result => result?.category?.raw === 'TV Guide'

const sortGuideResults = (results) => {
  if (results.length === 0) { return results }
  // return stv results before +1
  results.sort((a, b) => b.title.raw.localeCompare(a.title.raw))
  // sort by date asc
  return results.sort((a, b) => new Date(a.tvGuideDate.raw) - new Date(b.tvGuideDate.raw))
}

const processResults = (results) => {
  if (results?.filter) {
    const helpResults = results.filter(isHelp)
    const guideResults = sortGuideResults(results.filter(isGuide))
    const programmeResults = results.filter(result => (!isHelp(result) && !isGuide(result)))
    return [...programmeResults, ...guideResults, ...helpResults]
  }
  return []
}

export default processResults
